/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import logo from '../../src/img/logo.png';

class Logotipo extends Component {
  handleExibirLogotipo = () => (
    <React.Fragment>
      <div id="logo-comprev" style={{ textAlign: 'center', width: '100%', paddingTop: '100px' }}>
        <img src={logo} alt="img" />
      </div>
    </React.Fragment>
  );

  render() {
    return (
      <React.Fragment>
        {this.handleExibirLogotipo()}
      </React.Fragment>
    );
  }
}

export default Logotipo;



// WEBPACK FOOTER //
// ./src/pages/Logotipo.jsx